/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionRef,
  PersonSubscriptionRefOptional,
  PersonSubscriptionRefMetaI,
  PersonSubscriptionRefTrackedI,
} from "./person-subscription-ref";
import {
  PersonSubscriptionRefTracked,
  PersonSubscriptionRefMeta,
} from "./person-subscription-ref";

/**
 *
 * @export
 * @interface PersonSubscriptionBase
 */
export interface PersonSubscriptionBaseOptional extends PersonSubscriptionRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionBase
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingCycle?: string;
}

export interface PersonSubscriptionBase
  extends PersonSubscriptionBaseOptional, PersonSubscriptionRef {
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionBase
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingCycle: string;
}

export interface PersonSubscriptionBaseTrackedI extends PersonSubscriptionRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionBase
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingDate?: Date;
  billingDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionBase
   */
  billingCycle?: string;
  billingCycleIsSet: boolean;
}

transformDatesMap.set(
  "PersonSubscriptionBase",
  function (model: PersonSubscriptionBase) {
    if (typeof model.billingDate == "string")
      model.billingDate = new Date(model.billingDate);
  },
);

export type PersonSubscriptionBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: true
  //isDatetime: false
  billingDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  billingCycle: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonSubscriptionBaseMeta: PersonSubscriptionBaseMetaI =
  {} as PersonSubscriptionBaseMetaI;
PersonSubscriptionBaseMeta = typeMeta("PersonSubscriptionBase", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  billingDate: propertyMeta(
    "billingDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  billingCycle: propertyMeta(
    "billingCycle",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonSubscriptionBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonSubscriptionRefMeta]);
  metaI.assignId.inheritedFrom = PersonSubscriptionRefMeta.assignId;
});

export class PersonSubscriptionBaseTracked
  extends PersonSubscriptionRefTracked
  implements PersonSubscriptionBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  billingDate__I?: Date = undefined;
  billingDateIsSet: boolean = false;
  set billingDate(v: undefined | Date) {
    if (v !== undefined) {
      this.billingDate__I = v;
      this.billingDateIsSet = true;
    } else {
      this.billingDate__I = v || undefined;
      this.billingDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get billingDate() {
    return this.billingDate__I;
  }
  billingCycle__I?: string = undefined;
  billingCycleIsSet: boolean = false;
  set billingCycle(v: undefined | string) {
    if (v !== undefined) {
      this.billingCycle__I = v;
      this.billingCycleIsSet = true;
    } else {
      this.billingCycle__I = v || undefined;
      this.billingCycleIsSet = true;
    }
    this.changeTracker = true;
  }
  get billingCycle() {
    return this.billingCycle__I;
  }
  constructor(
    config?: PersonSubscriptionBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonSubscriptionBaseOptional,
    options?: AssignOptions,
  ): PersonSubscriptionBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.billingDate &&
      this.billingDateApplyFilter(optionsRequired.filter)
    ) {
      this.billingDate = config.billingDate;
      if (optionsRequired.unassign) this.billingDateIsSet = false;
      else this.billingDateIsSet = true;
    }
    if (
      config.billingCycle &&
      this.billingCycleApplyFilter(optionsRequired.filter)
    ) {
      this.billingCycle = config.billingCycle;
      if (optionsRequired.unassign) this.billingCycleIsSet = false;
      else this.billingCycleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonSubscriptionBaseTrackedI {
    const cloned = {} as PersonSubscriptionBaseTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.billingDateIsSetDeep() &&
      this.billingDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingDateIsSet = true;
      cloned.billingDate = this.billingDate;
    } else {
      //cloned.billingDateIsSet = false
    }
    if (
      this.billingCycleIsSetDeep() &&
      this.billingCycleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingCycleIsSet = true;
      cloned.billingCycle = this.billingCycle;
    } else {
      //cloned.billingCycleIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonSubscriptionBaseTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.billingDateApplyFilter(filter)) this.billingDateIsSet = false;

    if (!this.billingCycleApplyFilter(filter)) this.billingCycleIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionBaseMeta.assignId,
      PersonSubscriptionBaseMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  billingDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionBaseMeta.billingDate,
      PersonSubscriptionBaseMeta,
      this.billingDate,
      this,
    );
  }
  billingDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingDateIsSet && this.billingDateApplyFilter(filter))
      return true;

    return false;
  }
  billingCycleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionBaseMeta.billingCycle,
      PersonSubscriptionBaseMeta,
      this.billingCycle,
      this,
    );
  }
  billingCycleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingCycleIsSet && this.billingCycleApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.billingDateIsSetDeep(filter)) return true;
    if (this.billingCycleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
